export { ReferFriendsDialog } from './ReferFriendsDialog.tsx';
